import type { MailboxInfo } from 'owa-client-types';
import { getMailManualSyncStore } from '../store/store';

export function getIsSyncingMailbox(mailboxInfo: MailboxInfo): boolean {
    return getMailManualSyncStore(mailboxInfo).isSyncingMailbox;
}
